
/*
* Copyright (c) 2021.  Blacksheepz media B.V.
* https://www.blacksheepz-media.com
* Ramon van Ophuizen
*/

import React, { createContext, useEffect, useState, useContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_DOWNLOADS } from '../queries'
import { useThemeData } from '../context/ThemeDataContext'
import { useAuthData } from './AuthProvider'
import Loading from "../screens/loading";
import {getRoles} from "../services/auth.service";

export const DownloadContext = createContext(null)

export function useDownloadData() {
  return useContext(DownloadContext)
}

export function DownloadProvider ({ children }) {
  const site_id = useThemeData().themeData.site.site_id;
  const photographerType = useThemeData().photographerType;
  const {auth, login_name} = useAuthData();

  const initialData = [];

  const [DownloadData, setDownloadData] = useState(initialData);

  const { loading: loadingDownload, error: errorDownload, data: dataDownload } =
  useQuery(GET_DOWNLOADS, {
    variables: {
      site_id: site_id,
      login_name: localStorage.hasOwnProperty('login_email') ? localStorage.getItem('login_email') : localStorage.getItem('login_name')
    },
    fetchPolicy: "no-cache",
    skip: !auth || site_id === '' || photographerType === 'printservice' || !login_name || getRoles() === 'school'
  })

  useEffect(() => {
    async function fetchData() {
      if (!loadingDownload && !errorDownload) {
        if (dataDownload) {
          return new Promise((resolve, reject) => {
            resolve(dataDownload.getDownloads);
          }).then((data) => {
            //console.log(data);
            setDownloadData(data)
          })
        }
      }
    }
    fetchData();
    
  }, [errorDownload, loadingDownload, dataDownload])

  if (loadingDownload) return <Loading/>
  return (
    <DownloadContext.Provider value={{DownloadData, loadingDownload}}>
      {children}
    </DownloadContext.Provider>
  )
}
